import { getMethod, postMethod } from '../common/api';

export const getCustomerEmails = async (body) => {
  return postMethod('/api/customer-emails', body);
};

export const getRegister = async ({ slug, date, end }) => {
  const query = {};
  if (date) query.date = date;
  if (end) query.end = end;
  return getMethod(`/api/v2/class-register/${slug}`, query);
};

export const searchAttendees = async ({ name, page = 1, perPage = 20 }) => {
  return getMethod('/api/v2/search', { query: name, type: 'attendee', page, perPage });
};

export const createAdhocEnrollment = async (body) => {
  return postMethod('/api/v2/enrollments/adhoc', body);
};

export const markAttendance = async (body) => {
  return postMethod('/api/v2/enrollments/attendance', body, {
    headers: { 'Content-Type': 'application/json' },
  });
};
